import { render, staticRenderFns } from "./StoreSplitAmountValueCell.vue?vue&type=template&id=6180620c&scoped=true"
import script from "./StoreSplitAmountValueCell.vue?vue&type=script&lang=ts"
export * from "./StoreSplitAmountValueCell.vue?vue&type=script&lang=ts"
import style0 from "./StoreSplitAmountValueCell.vue?vue&type=style&index=0&id=6180620c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6180620c",
  null
  
)

export default component.exports